export default __webpack_public_path__ + "static/media/3473.46c5fe76.png";